export const bedrooms = {
  type: 'Bedrooms',
  arType: 'غرف نوم',
  assets: [
    {
      id: 1,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_0301.jpg',
      title: '',
    },
    {
      id: 2,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_0356.jpg',
      title: '',
    },
    {
      id: 3,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_0375.jpg',
      title: '',
    },
    {
      id: 4,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_1246.jpg',
      title: '',
    },
    {
      id: 5,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_2656.jpg',
      title: '',
    },
    {
      id: 6,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_2659.jpg',
      title: '',
    },
    {
      id: 7,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_7841.jpg',
      title: '',
    },
    {
      id: 8,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_1348.jpg',
      title: '',
    },
    {
      id: 9,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_1256.jpg',
      title: '',
    },
    {
      id: 10,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_1254.jpg',
      title: '',
    },
    {
      id: 11,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_1249.jpg',
      title: '',
    },
    {
      id: 12,
      img: 'https://storage.googleapis.com/door-assets/site/bedrooms/IMG_1049.jpg',
      title: '',
    },
  ]
};
